import { useContext, useState } from "react";
import { PaymentMethodType, } from "../../../../Account/BillingInformation/Shared/types/PaymentProcessorTypes";
import { createOptions, makeCreditCardOption, makeGiftCardOption, sortCards, } from "./PaymentMethodField-utils";
import { BillingInformationContext } from "../../../../Account/BillingInformation/BillingInformationContext";
export const usePaymentMethodField = ({ giftCards, creditCards, selectedGiftCard, setSelectedGiftCard, selectedCreditCard, setSelectedCreditCard, setShowTextBox, }) => {
    const { addedNewCard, setAddedNewCard } = useContext(BillingInformationContext);
    const primaryCard = creditCards === null || creditCards === void 0 ? void 0 : creditCards.find((card) => card.isPrimary);
    const defaultCard = !!primaryCard ? primaryCard : (creditCards === null || creditCards === void 0 ? void 0 : creditCards.length) ? creditCards[0] : undefined;
    const defaultCardOption = selectedCreditCard
        ? makeCreditCardOption(selectedCreditCard)
        : defaultCard
            ? makeCreditCardOption(defaultCard)
            : undefined;
    const [options, setOptions] = useState(createOptions(creditCards, giftCards));
    const [cardsSelected, setCardsSelected] = useState(defaultCardOption ? [defaultCardOption] : []);
    const [cardSearch, setCardSearch] = useState(undefined);
    const updateSelections = (selectedOptions) => {
        setCardsSelected(sortCards(selectedOptions));
        const selectedGiftCardOption = selectedOptions.find((option) => option.type === PaymentMethodType.GIFTCARD);
        setSelectedGiftCard(selectedGiftCardOption === null || selectedGiftCardOption === void 0 ? void 0 : selectedGiftCardOption.giftCard);
        const selectedCreditCardOption = selectedOptions.find((option) => option.type === PaymentMethodType.CARD);
        setSelectedCreditCard(selectedCreditCardOption === null || selectedCreditCardOption === void 0 ? void 0 : selectedCreditCardOption.creditCard);
    };
    const updateValues = () => {
        var _a, _b, _c;
        const newOptions = createOptions(creditCards, giftCards);
        setOptions(newOptions);
        const newSelections = [];
        if (addedNewCard && (creditCards === null || creditCards === void 0 ? void 0 : creditCards.length)) {
            const newest = creditCards[creditCards.length - 1];
            newSelections.push((_a = newOptions.find(o => { var _a; return ((_a = o.creditCard) === null || _a === void 0 ? void 0 : _a.id) === newest.id; })) !== null && _a !== void 0 ? _a : makeCreditCardOption(newest));
            setAddedNewCard(false);
        }
        else if (selectedCreditCard) {
            newSelections.push((_b = newOptions.find(o => { var _a; return ((_a = o.creditCard) === null || _a === void 0 ? void 0 : _a.id) === selectedCreditCard.id; })) !== null && _b !== void 0 ? _b : makeCreditCardOption(selectedCreditCard));
        }
        if (selectedGiftCard) {
            newSelections.push((_c = newOptions.find(o => { var _a; return ((_a = o.giftCard) === null || _a === void 0 ? void 0 : _a.id) === selectedGiftCard.id; })) !== null && _c !== void 0 ? _c : makeGiftCardOption(selectedGiftCard));
        }
        updateSelections(newSelections);
    };
    return {
        options,
        setOptions,
        createOptions,
        cardSearch,
        setCardSearch,
        cardsSelected,
        updateSelections,
        updateValues,
    };
};
